import { z } from 'zod';

export const RegisterNetworkBodySchema = z.object({
  name: z.string().min(1),
  slug: z
    .string()
    .min(2)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
  description: z.string().nullable().optional(),
});

export type RegisterNetworkBody = z.infer<typeof RegisterNetworkBodySchema>;

export const RegisterNetworkResponseSchema = z.object({
  networkId: z.uuid(),
});

export type RegisterNetworkResponse = z.infer<typeof RegisterNetworkResponseSchema>;
